export default function writeStep(
  ctx: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  isActiveStep: boolean
): void {
  ctx.save();
  ctx.textBaseline = 'top';
  if (isActiveStep) {
    ctx.fillStyle = 'white';
  } else {
    ctx.fillStyle = 'darkgray';
  }
  ctx.fillText(text, x, y);
  ctx.restore();
}
